module.exports = __webpack_public_path__ + "img/valentin.bde94151.webp";